import { isElectron, room } from "../libs/roomnew";

export function getLocalAudioTrack(){
    if(room){
        return room.getLocalAudioTrack();
    }
    return null;
};

export const adjustSlider = (slider,value) => {
    const min = 0;
    const max = 1;
    // Calculate visible width
    const val = ((value - min) * 100) / (max - min);

    // Change these variables to the colors you need
    const fillLeft = "#7ea9d4";
    const fillRight = "#ffffff";

    slider.style.background = `linear-gradient(to right, ${fillLeft} ${val}%, ${fillRight} ${val}%`;
  };

  export function initBackdropLayer(){
    const images=[
        `${isElectron ? '../../' : ''}/images/virtual-background/Offices/office-2.jpg`,
        `${isElectron ? '../../' : ''}/images/virtual-background/Offices/office-1.jpg`,
        `${isElectron ? '../../' : ''}/images/virtual-background/Offices/office-3.jpg`,
        `${isElectron ? '../../' : ''}/images/virtual-background/Offices/office-4.jpg`
    ];
    const selectedImage=images[Math.floor(Math.random() * (images.length - 1))];
    $("#kino-end-backdrop").css('background-image',`url(${selectedImage})`)
}

export function showBackdropLayer(){
    $("#kino-end-backdrop").addClass('d-flex')
    setTimeout(() => {
        $("#kino-end-backdrop").addClass('backdrop-fadeIn')
    }, 100);
}
